import type { HexColor } from './ids';

export const TASK_STATUSES = [
  'backlog', 'todo', 'in_progress', 'in_review', 'done', 'canceled',
] as const;
export type TaskStatus = typeof TASK_STATUSES[number];

export const STATUS_CATEGORIES = ['start', 'progress', 'final'] as const;
export type StatusCategory = typeof STATUS_CATEGORIES[number];

export interface TaskStatusDef {
  id: TaskStatus;
  name: string;
  color: HexColor;
  category: StatusCategory;
  sortKey: string;
}
export const TERMINAL_STATUSES = ['done', 'canceled'] as const;

export const TASK_PRIORITIES = ['urgent', 'high', 'medium', 'low', 'none'] as const;
export type Priority = typeof TASK_PRIORITIES[number];

export const TASK_LINK_KINDS = ['blocks', 'relates'] as const;
export type TaskLinkKind = typeof TASK_LINK_KINDS[number];

export type TaskDepth = 0 | 1;

export type SubscriptionTargetKind = 'task' | 'project' | 'milestone';
export type SubscriptionState = 'on' | 'off';
export type WatchReason = 'creator' | 'assignee' | 'commenter' | 'manual';

export type PresenceState = 'online' | 'away' | 'dnd' | 'offline';

export const CHANNEL_KINDS = ['public', 'private', 'dm', 'group'] as const;
export type ChannelKind = typeof CHANNEL_KINDS[number];
export type ChannelMemberRole = 'owner' | 'member';

export type InboxState = 'unread' | 'read' | 'archived';

export const INBOX_KINDS = [
  'assigned',
  'assigned_check',
  'assigned_comment',
  'mention',
  'chat_mention',
  'comment_reply',
  'comment',
  'task_added',
  'task_changed',
  'status',
  'group_added',
  'chat_dm',
  'thread_reply',
  'birthday',
  'reminder',
] as const;
export type InboxKind = typeof INBOX_KINDS[number];
export type InboxSourceKind = 'task' | 'comment' | 'message' | 'user';

export type MentionSourceKind = 'task' | 'comment' | 'message';
export type MentionTargetKind = 'subject' | 'task' | 'project' | 'channel';

export type OpKind = 'insert' | 'update' | 'delete';
export type OpEntityTable =
  | 'user' | 'project' | 'folder' | 'milestone' | 'label' | 'taskType'
  | 'task' | 'checklistItem' | 'comment' | 'taskLink' | 'timeEntry'
  | 'subscription' | 'channel' | 'channelMember' | 'message' | 'reaction'
  | 'inboxItem' | 'attachment';
